





























import { Component, Vue } from 'vue-property-decorator'
import { StepKeys } from '../../variables/ACF_Key'
import Thumbs from '../../components/Thumbs.vue'
import Title from '../../components/Title.vue'
import Wizard from '../Wizard.vue'
import Retour from '../../components/Retour.vue'
import Ctas from '../../components/Ctas.vue'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Autocomplete } from '../../variables/autocomplete/autocomplete'
@Component({
  components: {
    Thumbs,
    Title,
    Wizard,
    Retour,
    Ctas
  }
})
export default class Etape2 extends Vue {
    // Datas de la vue :
    public ready = false
    // Data a transmettre au titre :
    public titleMain !: string
    // Datas a transmettre au thumb :
    public item1 !: string
    public item2 !: string
    public item3 !: string
    public item4 !: string
    public result !: string
    public department = ''
    // Vue actuelle
    public step = 4
    //* ************ <!>IMPORTANT<!> -> Object pour enregistrer le JSON récupéré par AXIOS
    public responseACF!: Record<string, string>

    sortACFForThisView (): void{
      // Appel la class permettant de lire le trie du JSON (API WP)
      const thumbInfo = new StepKeys(this.responseACF)
      if (thumbInfo) {
        // Ajouter la clef ACF des items de la vue
        /***
         * INFO si dessous à modifier celon le projet :
         */
        this.item1 = thumbInfo.getValue('work_type_1')
        this.item2 = thumbInfo.getValue('work_type_2')
        this.item3 = ''
        this.item4 = ''
        /***
         * Titre de la vue :
         */
        this.titleMain = thumbInfo.getSimpleValue('work_type_title')
        this.ready = true
      }
    }

    updateView (type : string) : void {
      if (type) {
        this.result = type
        this.appendInput()
      }
    }

    appendInput () : void {
      const input = document.querySelector('.disableInput')
      if (input) {
        input.classList.remove('disableInput')
        input.classList.add('appendInput')
        if (this.result) {
          const label = document.querySelector('.input-' + this.result)
          if (label) {
            label.classList.remove('disble-inner-input')
            this.updateTown()
          }
        }
      }
    }

    updateTown () : void {
    // Call the Autocomplete class
      const inputToAuto = document.querySelector('#filter_sector_dep')
      if (inputToAuto) {
        const parm = {
          allowTownSearch: 'true',
          allowDepartmentSearch: 'false',
          allowRegionSearch: 'false'
        }
        const input = new Autocomplete(inputToAuto, parm)
        const SearchField = document.querySelector('.autocomplete-wrapper')
        // Update vueData with user value if click in autocomplete menu
        if (SearchField) {
          SearchField.addEventListener(
            'click',
            (event) => {
              const element = event.target as HTMLInputElement
              if (element.classList.contains('autocomplete-choices-item')) {
                this.department = element.innerHTML
                this.$store.dispatch('saveStep4Departement', this.department)
              }
            },
            false
          )
        }
      }
    }

    /***
     * VUE STATE =>
     */
    mounted (): void {
      this.responseACF = this.$store.getters.getValueOfACF
      // Plus besoin de requetter l'api à partir de cette vue car la valeur des ACFs sont stockées dans le vuex
      if (this.responseACF) {
        this.sortACFForThisView()
      }
    }
}
